import { render, staticRenderFns } from "./DataViewSidebarLibraries.vue?vue&type=template&id=656ab2a7&scoped=true&"
import script from "./DataViewSidebarLibraries.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarLibraries.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarLibraries.vue?vue&type=style&index=0&id=656ab2a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ab2a7",
  null
  
)

export default component.exports